/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Star from "../logos/Star.svg";
import Person1 from "../images/Person1.svg";
import Person2 from "../images/Person2.svg";
import Image1 from "../images/image1.svg";
import Image2 from "../images/image2.svg";
import Image3 from "../images/image3.svg";
import Ideadox from "../logos/Ideadox.svg";
import Test from "../logos/Test.svg";
import Deliver from "../logos/Deliver.svg";
import Discover from "../logos/Discover.svg";
import Design from "../logos/Design.svg";
import UX from "../logos/UX.svg";
import Code from "../logos/Code.svg";
import Research from "../logos/Research.svg";
import Container from "../logos/Container.svg";
import LearnMore from "../logos/Learn more.svg";
import Linkedin from "../logos/Linkedin.svg";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import Grid2 from "@mui/material/Grid2";
import GreenBg from "../logos/Green bg.svg";
import TrueImpact from "../logos/Trueimpact.svg";
import done from "../logos/21done.svg";
import Capivara from "../logos/Capivara.svg";
import Radin from "../logos/Radinhealth.svg";
import Godocta from "../logos/Godocta.svg";
import Jinzai from "../logos/Jinzai.svg";
import Cliquify from "../logos/Cliquify.svg";
import vinita from "../logos/Vinita (1).svg";

const MainPage = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleLearMoreClick = () => {
    navigate("/aboutus");
  };

  return (
    <>
      <div
        style={{
          background: "linear-gradient(to bottom, #F0DFD8, #DBAB97)",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          maxWidth: "100%",
          padding: isMobile ? "1rem" : "0",
          overflowX: "hidden", // Prevent horizontal scrolling
          boxSizing: "border-box", // Include padding and border in element's total width and height
        }}
      >
        <header
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            padding: "1rem",
            boxSizing: "border-box",
            top: 5,
            position: "absolute",
          }}
        >
          <div>
            <img src={Ideadox} alt="Ideadox"></img>
          </div>
          {isMobile ? (
            <div>
              <Button
                className="border border-black mt-2 rounded-full"
                onClick={handleMenuOpen}
              >
                <MenuIcon />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent white
                    boxShadow: "none",
                  },
                }}
              >
                <MenuItem
                  onClick={handleMenuClose}
                  style={{
                    color: "#000",
                    fontFamily: "Golos Text",
                  }}
                >
                  Blog
                </MenuItem>
                <MenuItem
                  onClick={() => navigate("/caseStudy")}
                  style={{
                    color: "#000",
                    fontFamily: "Golos Text",
                  }}
                >
                  Case Study
                </MenuItem>
                <MenuItem
                  onClick={() => navigate("/aboutus")}
                  style={{
                    color: "#000",
                    fontFamily: "Golos Text",
                  }}
                >
                  About
                </MenuItem>
              </Menu>
              <button className="border border-black py-1 px-2 mt-2 rounded-full hover:bg-black hover:text-white">
                Get In Touch
              </button>
            </div>
          ) : (
            <nav className="space-x-4 mr-4">
              <button
                className="hover:underline"
                onClick={() => {
                  /* handle click */
                }}
              >
                Blog
              </button>
              <button
                className="hover:underline"
                onClick={() => {
                  navigate("/caseStudy");
                }}
              >
                Case Study
              </button>
              <button
                className="hover:underline"
                onClick={() => navigate("/aboutus")}
              >
                About
              </button>
              <button className="border border-black py-1 px-3 rounded-full hover:bg-black hover:text-white">
                Get In Touch
              </button>
            </nav>
          )}
        </header>
        <div
          style={{
            position: "relative",
            textAlign: "center",
            marginTop: "3rem",
          }}
        >
          {/* SVG Icons in a Half-Circle Above */}
          {!isMobile && (
            <>
              <img
                src={Design}
                alt="Design"
                style={{
                  position: "absolute",
                  top: "-160px",
                  left: "45%",
                  transform: "translateX(-50%)",
                }}
              />
              <img
                src={UX}
                alt="UX"
                style={{
                  position: "absolute",
                  top: "-110px",
                  left: "15%",
                }}
              />
              <img
                src={Code}
                alt="Test"
                style={{
                  position: "absolute",
                  top: "-120px",
                  right: "20%",
                }}
              />
              <img
                src={Research}
                alt="Research"
                style={{
                  position: "absolute",
                  top: "-60px",
                  left: "-5%",
                }}
              />
              <img
                src={Test}
                alt="test"
                style={{
                  position: "absolute",
                  top: "-60px",
                  right: "-7%",
                }}
              />
              <img
                src={Discover}
                alt="Discover"
                style={{
                  position: "absolute",
                  marginTop: "10%",
                  left: "-8%",
                }}
              />
              <img
                src={Deliver}
                alt="deliver"
                style={{
                  position: "absolute",
                  marginTop: "10%",
                  right: "-4%",
                }}
              />
            </>
          )}

          <Typography
            style={{
              fontSize: isMobile ? 55 : 75,
              fontWeight: 550,
              lineHeight: isMobile ? "66px" : "86px",
              fontFamily: "Bricolage Grotesque",
              marginBottom: "-28px",
              marginTop: isMobile ? "-70px" : "",
            }}
          >
            Where{" "}
            {!isMobile && (
              <span
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                <img
                  src={Container}
                  alt="Container"
                  style={{ position: "relative", top: "2px" }}
                />
              </span>
            )}{" "}
            Ideas Thrive
          </Typography>
          <Typography
            style={{
              fontWeight: 150,
              fontSize: 28,
              fontFamily: "'Bricolage Grotesque', sans-serif",
              color: "#78787D",
              textAlign: "center",
              marginTop: "1.5rem",
            }}
          >
            Building Scalable,
          </Typography>
          <Typography
            style={{
              fontWeight: 150,
              fontSize: 28,
              fontFamily: "'Bricolage Grotesque', sans-serif",
              color: "#78787D",
              textAlign: "center",
              marginBottom: "1.5rem",
            }}
          >
            Market-Ready Products from Scratch
          </Typography>
          <button onClick={handleLearMoreClick} style={{ textAlign: "center" }}>
            <img
              src={LearnMore}
              alt="learn more"
              style={{
                width: "250px", // Adjust width as needed
                display: "inline-block",
              }}
            />
          </button>
        </div>
        {!isMobile && (
          <footer className="absolute bottom-0 left-10 right-0 p-4 flex justify-center space-x-10">
            <img
              src={TrueImpact}
              alt="True"
              className={isMobile ? "animate-circle-mobile" : "animate-circle"}
            />
            <img
              src={done}
              alt="21done"
              className={isMobile ? "animate-circle-mobile" : "animate-circle"}
            />
            <img
              src={Radin}
              alt="True"
              className={isMobile ? "animate-circle-mobile" : "animate-circle"}
            />
            <img
              src={vinita}
              alt="True"
              className={isMobile ? "animate-circle-mobile" : "animate-circle"}
            />
            <img
              src={Jinzai}
              alt="True"
              className={isMobile ? "animate-circle-mobile" : "animate-circle"}
            />
            <img
              src={Cliquify}
              alt="True"
              className={isMobile ? "animate-circle-mobile" : "animate-circle"}
            />
            <img
              src={Capivara}
              alt="True"
              className={isMobile ? "animate-circle-mobile" : "animate-circle"}
            />
            <img
              src={Godocta}
              alt="True"
              className={isMobile ? "animate-circle-mobile" : "animate-circle"}
            />
          </footer>
        )}
      </div>

      <div
        style={{
          backgroundColor: "#F0DFD8",
          minHeight: "50vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          maxWidth: "100%",
          padding: isMobile ? "1rem" : "2rem",
          overflowX: "hidden", // Prevent horizontal scrolling
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "1rem",
          }}
        >
          <img
            src={Star}
            alt="Star"
            style={{
              marginRight: "0.5rem",
              marginBottom: isMobile ? "25px" : "",
            }}
          />
          <Typography
            style={{
              fontSize: isMobile ? 20 : 18,
              fontFamily: "Bricolage Grotesque",
              fontWeight: 200,
              color: "#2F2F30",
            }}
          >
            Turning Ideas into Realities One Step at a Time.
          </Typography>
        </div>
        <Typography
          style={{
            fontSize: isMobile ? "20px" : "26px",
            fontFamily: "Golos Text",
            maxWidth: "600px",
            marginTop: "25px",
            textAlign: "center",
          }}
        >
          <span style={{ color: "#2F2F30" }}>
            At Ideadox, we transform bold ideas into innovative digital
            products.
          </span>
          <span style={{ color: "#78787A" }}>
            {" "}
            From custom websites to groundbreaking apps, our team of designers
            and developers crafts unique solutions tailored to each client. No
            project is too big or concept too ambitious – we’re here to turn
            your vision into a digital success.
          </span>
        </Typography>
      </div>

      <div
        style={{
          backgroundColor: "#F0DFD8",
          padding: "2rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "1rem",
          }}
        >
          <img src={Star} alt="Star" style={{ marginRight: "0.5rem" }} />
          <Typography
            style={{
              fontSize: 18,
              fontFamily: "Bricolage Grotesque",
              fontWeight: 200,
              color: "#2F2F30",
            }}
          >
            Meet Our Founders.
          </Typography>
        </div>
        <Typography
          style={{
            fontSize: isMobile ? "1.4rem" : "1.8rem",
            fontFamily: "Golos Text",
            marginBottom: "2rem",
            marginTop: isMobile ? "10px" : "20px",
            textAlign: "center",
          }}
        >
          Meet the dynamic duo steering this ship
          <br />
          towards uncharted territories of innovation.
        </Typography>

        <Grid2 container spacing={12} maxWidth="650px" margin="auto">
          <Grid2 container item xs={12} md={6} alignItems="center" spacing={2}>
            <Grid2
              item
              xs={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: "center",
                textAlign: isMobile ? "center" : "left",
              }}
            >
              <div style={{ marginBottom: isMobile ? "1rem" : "0" }}>
                <img
                  src={Person1}
                  alt="Dipali Lohar"
                  className="w-48 h-48"
                  style={{ borderRadius: "50%" }}
                />
                <Typography
                  style={{
                    fontWeight: 700,
                    fontFamily: "Golos Text",
                    fontSize: "23px",
                    marginTop: "0.5rem",
                  }}
                >
                  Dipali Lohar
                </Typography>
                <Typography
                  style={{ fontFamily: "Golos Text", whiteSpace: "nowrap" }}
                >
                  <span
                    style={{ display: "inline-flex", alignItems: "center" }}
                  >
                    CEO & Co-Founder
                    <a
                      href="https://www.linkedin.com/in/dipali-lohar-67578717b/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginLeft: "1rem", display: "inline-block" }}
                    >
                      <img src={Linkedin} alt="Linkedin" />
                    </a>
                  </span>
                </Typography>
              </div>
              <div
                style={{
                  maxWidth: "400px",
                  marginLeft: isMobile ? "0" : "4rem",
                  marginTop: isMobile ? "0" : "-8px",
                }}
              >
                <Typography
                  style={{
                    fontWeight: 300,
                    marginTop: "0.5rem",
                    fontFamily: "Golos Text",
                    fontSize: "23px",
                  }}
                >
                  Cultivating Client's Concepts into Ingenious Interface
                  Designs.
                </Typography>
                <Typography
                  style={{
                    color: "#78787A",
                    marginTop: "0.5rem",
                    fontFamily: "Golos Text",
                  }}
                >
                  With a passion for providing personalized solutions, Dipali is
                  the point of connection between innovation and implementation.
                  Acclaimed for excellent customer connection and comprehensive
                  research, she crafts meticulous solutions from scratch,
                  delivering UX Product that reflect a deep understanding of
                  user problem.
                </Typography>
              </div>
            </Grid2>
          </Grid2>
          <Grid2 container item xs={12} md={9} alignItems="center" spacing={2}>
            <Grid2
              item
              xs={12}
              md={8}
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: isMobile ? "column" : "row",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  textAlign: isMobile ? "center" : "left",
                  marginRight: isMobile ? "0" : "1rem",
                  maxWidth: "400px",
                }}
              >
                <Typography
                  style={{
                    fontWeight: 300,
                    marginTop: isMobile ? "-25px" : "0.5rem",
                    fontFamily: "Golos Text",
                    fontSize: "23px",
                  }}
                >
                  Turning Vision into Action. From Initial Research to Deployed
                  Product.
                </Typography>
                <Typography
                  style={{
                    color: "#78787A",
                    marginTop: "0.5rem",
                    fontFamily: "Golos Text",
                  }}
                >
                  Championing technical finesse and the art of solution-building
                  methodologies, Prakash has mastered identifying client
                  requirements and translating them into effective products.
                  Ensuring seamless operations from start to finish, you can
                  count on him to manage the entire process for creating your
                  next digital success story.
                </Typography>
              </div>
              <div style={{ textAlign: "center" }}>
                <img
                  src={Person2}
                  alt="Prakash Perumal"
                  className="w-48 h-48"
                  style={{ borderRadius: "50%", marginBottom: "1rem" }}
                />
                <Typography
                  style={{
                    fontWeight: 700,
                    fontFamily: "Golos Text",
                    fontSize: "22px",
                  }}
                >
                  Prakash Perumal
                </Typography>
                <Typography
                  style={{ fontFamily: "Golos Text", whiteSpace: "nowrap" }}
                >
                  <span
                    style={{ display: "inline-flex", alignItems: "center" }}
                  >
                    Chief Technology Officer
                    <a
                      href="https://www.linkedin.com/in/prakash-perumal-tech/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginLeft: "0.5rem", display: "inline-block" }}
                    >
                      <img src={Linkedin} alt="Linkedin" />
                    </a>
                  </span>
                </Typography>
              </div>
            </Grid2>
          </Grid2>
        </Grid2>
      </div>
      <div
        style={{
          backgroundColor: "#F0DFD8",
          padding: "2rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "1rem",
          }}
        >
          <img src={Star} alt="Star" style={{ marginRight: "0.5rem" }} />
          <Typography
            style={{
              fontSize: 18,
              fontFamily: "Bricolage Grotesque",
              fontWeight: 200,
              color: "#2F2F30",
            }}
          >
            Read our Blogs.
          </Typography>
        </div>
        <Typography
          style={{
            fontSize: "26px",
            fontFamily: "Golos Text",
            maxWidth: "600px",
            marginTop: "25px",
          }}
        >
          <span style={{ color: "#2F2F30" }}>
            We’re honored to have partnered with a diverse array of clients.
          </span>
          <span style={{ color: "#78787A" }}>
            {" "}
            To us, every project is a fresh opportunity to create something
            extraordinary.
          </span>
        </Typography>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "2rem",
            padding: "2rem",
            flexDirection: isMobile ? "column" : "row", // Stack vertically on mobile
            alignItems: "center", // Center items when stacked
          }}
        >
          <div
            style={{
              backgroundColor: "#9EB2B0",
              borderRadius: "42px",
              padding: "1rem",
              width: "300px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              textAlign: "left",
            }}
          >
            <img
              src={Image1}
              alt="Person 1"
              style={{ borderRadius: "50%", width: "50px", height: "50px" }}
            />
            <Typography
              style={{
                color: "#FFFFFF",
                marginTop: "-50px",
                fontFamily: "Bricolage Grotesque",
                textAlign: "center",
                fontSize: "28px",
              }}
            >
              loom
            </Typography>
            <Typography
              style={{
                marginTop: "2.5rem",
                color: "#fff",
                fontSize: "15px",
                fontFamily: "Golos Text",
              }}
            >
              Once again, we continue to work with Ideadox for multiple
              corporate and professional requirements as they are quick,
              efficient, and provide quality work and documentation so that we
              can leave the job not only knowing it was done right but also
              understanding it.
            </Typography>
            <Typography
              style={{
                marginTop: "0.5rem",
                color: "#fff",
                fontFamily: "Golos Text",
                marginLeft: "10px",
              }}
            >
              Happyplanetinc
            </Typography>
            <Typography
              style={{
                marginBottom: "0.5rem",
                color: "#fff",
                fontFamily: "Golos Text",
                marginLeft: "10px",
                fontWeight: 600,
              }}
            >
              United States
            </Typography>
            <Typography
              style={{
                color: "#fff",
                cursor: "pointer",
                fontFamily: "Golos Text",
                marginLeft: "10px",
              }}
            >
              Read More →
            </Typography>
          </div>
          <div
            style={{
              backgroundColor: "#DBAB97",
              borderRadius: "42px",
              padding: "1rem",
              width: "300px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              textAlign: "left",
            }}
          >
            <img
              src={Image2}
              alt="Person 2"
              style={{ borderRadius: "50%", width: "50px", height: "50px" }}
            />
            <Typography
              style={{
                color: "#FFFFFF",
                marginTop: "-40px",
                fontFamily: "Bricolage Grotesque",
                textAlign: "center",
                fontSize: "25px",
              }}
            >
              INTERCOM
            </Typography>
            <Typography
              style={{
                marginTop: "2rem",
                color: "#fff",
                fontSize: "16px",
                fontFamily: "Golos Text",
              }}
            >
              They went above and beyond to complete the project and finished
              way before the delivery deadline. Dipali understood the
              requirement very quickly and was able to provide...
            </Typography>
            <Typography
              style={{
                marginTop: "2.5rem",
                color: "#fff",
                fontFamily: "Golos Text",
                marginLeft: "10px",
              }}
            >
              Sameer Khanna
            </Typography>
            <Typography
              style={{
                marginBottom: "1rem",
                color: "#fff",
                fontFamily: "Golos Text",
                marginLeft: "10px",
                fontWeight: 600,
              }}
            >
              United States
            </Typography>
            <Typography
              style={{
                color: "#fff",
                cursor: "pointer",
                fontFamily: "Golos Text",
                marginLeft: "10px",
              }}
            >
              Read More →
            </Typography>
          </div>
          <div
            style={{
              backgroundColor: "#5F5E61",
              borderRadius: "42px",
              padding: "1rem",
              width: "300px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
              textAlign: "left",
            }}
          >
            <img
              src={Image3}
              alt="Person 3"
              style={{ borderRadius: "50%", width: "50px", height: "50px" }}
            />
            <Typography
              style={{
                color: "#FFFFFF",
                marginTop: "-40px",
                fontFamily: "Bricolage Grotesque",
                textAlign: "center",
                fontSize: "25px",
              }}
            >
              Abstract
            </Typography>
            <Typography
              style={{
                marginTop: "2rem",
                color: "#fff",
                fontSize: "16px",
                fontFamily: "Golos Text",
              }}
            >
              MAU 25K and counting... scalable infrastructure at low cost. It's
              a long partnership and truly rewarding.
            </Typography>
            <Typography
              style={{
                marginTop: "5.5rem",
                color: "#fff",
                fontFamily: "Golos Text",
                marginLeft: "10px",
              }}
            >
              Vinita
            </Typography>
            <Typography
              style={{
                marginBottom: "1rem",
                color: "#fff",
                fontFamily: "Golos Text",
                marginLeft: "10px",
                fontWeight: 600,
              }}
            >
              USA
            </Typography>
            <Typography
              style={{
                color: "#fff",
                cursor: "pointer",
                fontFamily: "Golos Text",
                marginLeft: "10px",
              }}
            >
              Read More →
            </Typography>
          </div>
        </div>
        <div
          style={{
            padding: "2rem",
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Typography
              style={{
                fontSize: 60,
                background: "linear-gradient(to right, #2F2F30, #78787A)",
                WebkitBackgroundClip: "text",
                color: "transparent",
              }}
            >
              30+
            </Typography>
            <Typography style={{ color: "#78787A" }}>Projects</Typography>
          </div>
          <div style={{ textAlign: "center" }}>
            <Typography
              style={{
                fontSize: 60,
                background: "linear-gradient(to right, #2F2F30, #78787A)",
                WebkitBackgroundClip: "text",
                color: "transparent",
              }}
            >
              10+
            </Typography>
            <Typography style={{ color: "#78787A" }}>
              Repeat Customers
            </Typography>
          </div>
          <div style={{ textAlign: "center" }}>
            <Typography
              style={{
                fontSize: 60,
                background: "linear-gradient(to right, #2F2F30, #78787A)",
                WebkitBackgroundClip: "text",
                color: "transparent",
              }}
            >
              4.9
            </Typography>
            <Typography style={{ color: "#78787A" }}>Rating</Typography>
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#F0DFD8",
            padding: "3rem 2rem",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
            minHeight: "200px",
          }}
        >
          <img
            src={GreenBg}
            alt="Green Background"
            style={{
              position: "absolute",
              top: "-100px", // Move the SVG further up
              left: "50%",
              transform: "translateX(-50%)",
              width: "150%", // Increase width to cover the area
              zIndex: -1,
            }}
          />
          <Typography
            style={{
              fontSize: isMobile ? "22px" : "35px",
              color: "#2F2F30",
              marginBottom: "1rem",
              marginTop: isMobile ? "-40px" : "",
              fontFamily: "Golos Text",
              fontWeight: 400,
            }}
          >
            Transforming ideas into standout{" "}
            <span style={{ color: "#78787A" }}>product for your business.</span>
          </Typography>
          <Typography
            style={{
              color: "#78787A",
              marginBottom: "2rem",
              fontSize: isMobile ? "13px" : "18px",
              fontFamily: "Golos Text",
              fontWeight: 400,
            }}
          >
            Get ready to create stunning, efficient ideas without the hassle of
            hiring!
          </Typography>
          <form
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: isMobile ? "column" : "row",
              alignItems: "center",
              gap: "1rem",
              marginTop: "1.5rem",
            }}
          >
            <input
              type="email"
              placeholder="name@email.com"
              style={{
                padding: "0.5rem 1rem",
                borderRadius: "25px",
                border: "1px solid #2F2F30",
                width: "250px",
                backgroundColor: "transparent", // Make background transparent
                color: "#2F2F30", // Text
              }}
            />
            <button
              type="submit"
              style={{
                padding: isMobile ? "0.3rem 0.5rem" : "0.5rem 0.5rem",
                borderRadius: "25px",
                backgroundColor: "#2F2F30",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                width: isMobile ? "60%" : "auto",
                marginTop: isMobile ? "0.1rem" : "0",
              }}
            >
              Get notified
            </button>
          </form>
        </div>
        <footer
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            marginTop: isMobile ? 0 : 5,
            padding: isMobile ? "1rem" : "0.5rem",
          }}
        >
          <div
            className="flex flex-col md:flex-row items-center"
            style={{ gap: isMobile ? "1rem" : "2rem" }}
          >
            <img
              src={Ideadox}
              alt="Ideadox"
              className="mb-4 md:mb-0"
              style={{ width: isMobile ? "80px" : "auto" }}
            />
            <div
              className="flex justify-center"
              style={{
                gap: isMobile ? "1rem" : "2rem",
                marginLeft: isMobile ? "0" : "24rem",
              }}
            >
              <button
                className="hover:underline"
                style={{
                  fontFamily: "DM Sans",
                  fontWeight: 500,
                  fontSize: isMobile ? "16px" : "20px",
                }}
              >
                Blog
              </button>
              <button
                onClick={() => {
                  navigate("/caseStudy");
                }}
                className="hover:underline"
                style={{
                  fontFamily: "DM Sans",
                  fontWeight: 500,
                  fontSize: isMobile ? "16px" : "20px",
                }}
              >
                Case Study
              </button>
              <button
                onClick={() => {
                  navigate("/aboutus");
                }}
                className="hover:underline"
                style={{
                  fontFamily: "DM Sans",
                  fontWeight: 500,
                  fontSize: isMobile ? "16px" : "20px",
                }}
              >
                About
              </button>
            </div>
          </div>
          <div
            className="flex items-center justify-center"
            style={{
              gap: isMobile ? "1rem" : "2rem",
              marginTop: isMobile ? "1rem" : "0",
            }}
          >
            <button
              className="text-black"
              style={{
                fontFamily: "Golos Text",
                fontSize: isMobile ? "15px" : "17px",
              }}
            >
              Contact us
            </button>
            <a
              href="https://www.linkedin.com/company/ideadox/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: "0.5rem", display: "inline-block" }}
            >
              <img
                src={Linkedin}
                alt="LinkedIn"
                className="w-10 h-10"
                style={{ width: isMobile ? "30px" : "40px" }}
              />
            </a>
          </div>
        </footer>
      </div>
      <style>
        {`
          @keyframes circleAnimation {
            0% {
              transform: translateX(0);
            }
            25% {
              transform: translateX(-50px);
            }
            50% {
              transform: translateX(-100px);
            }
            75% {
              transform: translateX(-50px);
            }
            100% {
              transform: translateX(0);
            }
          }

          @keyframes circleAnimationMobile {
            0% {
              transform: translate(0, 0);
            }
            25% {
              transform: translate(20px, -20px);
            }
            50% {
              transform: translate(40px, 0);
            }
            75% {
              transform: translate(20px, 20px);
            }
            100% {
              transform: translate(0, 0);
            }
          }

          .animate-circle {
            animation: circleAnimation 4s infinite;
          }

          .animate-circle-mobile {
            animation: circleAnimationMobile 4s infinite linear;
          }
        `}
      </style>
    </>
  );
};

export default MainPage;
